import type { ReactElement } from 'react';
import { useState, isValidElement, cloneElement } from 'react';
import { Layout } from 'antd';
import styles from '@/styles/chat.module.css';
import Footer from '@/components/Footer';

const { Sider, Content } = Layout;

const ChatLayout = ({ children }: any) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={styles.chatpage}>
      <Sider
        width={'20%'}
        style={{ margin: collapsed ? '20px 0 0 20px' : '0' }}
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
      >
        {isValidElement(children[0])
          ? cloneElement(children[0] as ReactElement<any>, {
            collapsed,
            setCollapsed,
          })
          : null}
      </Sider>
      <Layout style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Content style={{ margin: '16px', background: '#fff', padding: 24, overflow: 'auto' }}>
          {children[1]}
        </Content>
        <Footer />
      </Layout>
    </div>
  );
};

export default ChatLayout;
